<mat-dialog-content>
  <div class="grid tk-grid-rows place-items-center  custom-font">
    <div class="mx-auto flex-1 flex-col place-items-center">

      <div class="mb-16 grid place-items-center">
        <div class="i-client-error"></div>
      </div>

      <div class="text-xl text-white font-semibold text-center mb-3 w-70">
        {{'internetConnectionProblem'|translate}}
      </div>

      <div class="text-xs text-white text-center w-70">
        {{'internetConnectionProblemDescription'|translate}}
      </div>

    </div>

    <button mat-flat-button color="primary" type="button"
            class=" flex justify-center items-center font-normal hover:font-normal"
            (click)="onSubmit()">
      <div class=" mx-6 text-sm text-white">
        {{'refreshApp'|translate}}
      </div>
    </button>

  </div>
</mat-dialog-content>
